export default __webpack_public_path__ + "static/media/account-bank.d3980c50.svg";